const ENCODING = 'base64'
const PRIMART_DELIMETER = ';'
const INNER_DELIMETER = '='

export type ModulesToLoad = Array<{ id: string; url: string }>

const urlMappings = [
	['https://static.parastorage.com/services/', 'p.'],
	['https://sled.wix.dev/sled-wixplatform-bundle/', 's.'],
]

const compressUrl = (url: string) => {
	return urlMappings.reduce((acc, [pattern, replacer]) => acc.replace(pattern, replacer), url)
}

const decompressUrl = (compressedUrl: string) => {
	return urlMappings.reduce(
		(acc, [pattern, replacer]) => (acc.slice(0, replacer.length) === replacer ? pattern + acc.slice(2) : acc),
		compressedUrl
	)
}

export const encodeModulesToLoad = (items: ModulesToLoad) =>
	Buffer.from(
		items.map(({ id, url }) => `${id}${INNER_DELIMETER}${compressUrl(url)}`).join(PRIMART_DELIMETER)
	).toString(ENCODING)

export const decodeModulesToLoad = (raw: string): ModulesToLoad =>
	Buffer.from(raw, ENCODING)
		.toString('ascii')
		.split(PRIMART_DELIMETER)
		.filter(Boolean)
		.map((item) => {
			const [id, url] = item.split(INNER_DELIMETER)
			return { id, url: decompressUrl(url) }
		})
